import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { Grid, Typography, Tabs, Tab } from '@material-ui/core';

import GuidesRulesTab from './GuidesRulesTab';
// eslint-disable-next-line import/no-named-as-default
import GuidePluginConfiguration from './GuidePluginConfiguration';

const styles = (theme) => ({
    yeselfTabs: {
        marginBottom: theme.typography.pxToRem(35),
    },
    tab: {
        paddingRight: theme.typography.pxToRem(30),
        paddingLeft: theme.typography.pxToRem(30),
        [theme.breakpoints.between('xs', 'md')]: {
            paddingRight: theme.typography.pxToRem(0),
            paddingLeft: theme.typography.pxToRem(0),
        },
    },
});

const GuideListItemGeneralTabs = ({
    form,
    intl,
    appId,
    tabOpened,
    onTabChange,
    showGuideDetail,
    editGuide,
    guide,
    classes,
}) => (
    <Grid>
        <Tabs
            id="yeself-guide-tabs"
            value={tabOpened}
            indicatorColor="primary"
            textColor="primary"
            onChange={onTabChange}
            className={classes.yeselfTabs}
        >
            <Tab
                id="yeself-guide-tab-rules"
                disableRipple
                label={intl.formatMessage({
                    id: 'Guides.rules',
                })}
            />

            <Tab
                id="yeself-guide-tab-plagin"
                disableRipple
                label={intl.formatMessage({
                    id: 'Guides.pluginConfiguration',
                })}
            />
        </Tabs>

        {tabOpened === 0 && showGuideDetail && (
            <GuidesRulesTab className={classes.tab} isEditMode={editGuide} guide={guide} form={form} />
        )}

        {tabOpened === 1 && (
            <GuidePluginConfiguration guideId={guide.id} guideType={guide.type} applicationId={appId} />
        )}
    </Grid>
);

export default withStyles(styles)(injectIntl(GuideListItemGeneralTabs));
